import { InfoCircledIcon, PaperPlaneIcon } from "@radix-ui/react-icons";
import { Dialog } from "components/Dialog";
import { DialogTrigger } from "@radix-ui/react-dialog";
import { Button, ButtonColor, ButtonFill, ButtonSize } from "components/Button";

import {
  ParentLimitedResponse,
  StudentLimitedResponse,
  TutorLimitedResponse,
  MessageResponse,
} from "client/openapi";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/Tooltip";
import "../index.css";
import { useContext, useState } from "react";
import { OrgRolesAndAccountContext } from "util/OrgRolesAccountContext";
import CommunicationDialog from "components/CommunicationDialog";
import ComposeMessageDialog from "components/Dashboard/ComposeMessageDialog";

export default function Communication({
  title,
  parent,
  student,
  tutor,
  toolTipMessage,
}: {
  title: string;
  parent?: ParentLimitedResponse;
  student?: StudentLimitedResponse;
  tutor?: TutorLimitedResponse;
  toolTipMessage?: string;
}) {
  const { currently_selected_role } = useContext(OrgRolesAndAccountContext);
  const [newMessageOpen, setNewMessageOpen] = useState<boolean>(false);
  const [messages, setMessages] = useState<MessageResponse[]>([]);

  return (
    <section className="profile-box--section" id="parent-communication">
      <div className="profile-box--section-header">
        <div className="flex flex-row items-center">
          <h2>{title}</h2>
          {toolTipMessage && (
            <div className="ml-2 mr-2">
              <Tooltip>
                <TooltipTrigger>
                  <InfoCircledIcon className="w-5 h-5 text-gray-400" />
                </TooltipTrigger>
                <TooltipContent>{toolTipMessage}</TooltipContent>
              </Tooltip>
            </div>
          )}
        </div>

        <Dialog open={newMessageOpen} onOpenChange={setNewMessageOpen}>
          <DialogTrigger>
            <Button
              size={ButtonSize.EXTRA_SMALL}
              color={ButtonColor.DARK_BLUE}
              fill={ButtonFill.HOLLOW}
            >
              Send Message <PaperPlaneIcon />
            </Button>
          </DialogTrigger>
          {newMessageOpen && (
            <ComposeMessageDialog
              students={student ? [student] : undefined}
              tutors={tutor ? [tutor] : undefined}
              parents={parent ? [parent] : undefined}
              org_id={
                (student?.org_id || tutor?.org_id || parent?.org_id) as number
              }
            />
          )}
        </Dialog>
      </div>

      <div className="profile-box--section-items">
        <div className="profile-box--section-item">
          <CommunicationDialog
            parent={parent}
            student={student}
            tutor={tutor}
            messages={messages}
            setMessages={setMessages}
          />
        </div>
      </div>
    </section>
  );
}
